/**
 * Defines the KPI-tracked default first node of every production conversation.
 */
export const MESSENGER_ENTRYPOINT_INTENT = "messenger_entrypoint" as const;
